import { render, staticRenderFns } from "./CardCarousel.vue?vue&type=template&id=10dcde4e&scoped=true&"
import script from "./CardCarousel.vue?vue&type=script&lang=js&"
export * from "./CardCarousel.vue?vue&type=script&lang=js&"
import style0 from "./CardCarousel.vue?vue&type=style&index=0&id=10dcde4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dcde4e",
  null
  
)

export default component.exports